// node_modules
import { FC, useState, MouseEvent, useContext } from "react";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouteMatch } from "react-router-dom";
// styles
import styles from "./sidebarMenu.module.scss";
// Components
import { SidebarMenuItem } from "./SidebarMenuItem";
// Contexts
import { DeliveryLayoutContext } from "Providers";

type TSidebarMenuProps = {
    selectedName?: string;
    children: (JSX.Element | null)[];
};

export const SidebarMenu: FC<TSidebarMenuProps> = ({ children, selectedName } : TSidebarMenuProps) => {
    // Contexts
    const {
        isLeftSidebarCollapsed,
        setIsLeftSidebarCollapsed,
        isOnLeftSidebarHoverCollapsed,
        setIsOnLeftSidebarHoverCollapsed
    } = useContext(DeliveryLayoutContext);

    const nonNullChildren = children.filter((child) => { return child !== null; }) as JSX.Element[];
    const [selectedItemName, setSelectedItemName] = useState(selectedName ? selectedName: nonNullChildren[0].props.title.toLowerCase());

    const { url } = useRouteMatch();
    const realRoute = useRouteMatch(`${url}/:sideBarItem`);
    if(realRoute?.params) {
        if("sideBarItem" in realRoute.params) {
            const params = realRoute.params as { sideBarItem: string };
            if(params.sideBarItem.toLowerCase() !== selectedItemName) setSelectedItemName(params.sideBarItem);
        }
    }
    
    const getAsideClassName = (): string => {
        const classNameList = [styles.sidebarMenu];
        if(isLeftSidebarCollapsed) classNameList.push(styles.sidebarMenuCollapsed);
        return classNameList.join(" ");
    };

    const getCollapseClassName = (): string => {
        const classNameList = [styles.collapseOrUncollapseSidebarMenu];
        if(isLeftSidebarCollapsed) classNameList.push(styles.uncollapseSidebarMenu);                  
        return classNameList.join(" ");
    };

    const handleOnAndOffHoverCollapsedSidebarLeft = (mouseEvent: MouseEvent): void => {
        if (isLeftSidebarCollapsed) {
            setIsOnLeftSidebarHoverCollapsed(!isOnLeftSidebarHoverCollapsed);
        } else {
            return;
        }
    };

    function handleOnClickSetIsCollapsedSidebarLeft() {
        setIsLeftSidebarCollapsed(!isLeftSidebarCollapsed);
        setIsOnLeftSidebarHoverCollapsed(!isOnLeftSidebarHoverCollapsed);
    }
    
    return (
        <aside className={getAsideClassName()} 
        onMouseEnter={handleOnAndOffHoverCollapsedSidebarLeft} 
        onMouseLeave={handleOnAndOffHoverCollapsedSidebarLeft} >
            <div onClick={handleOnClickSetIsCollapsedSidebarLeft} className={getCollapseClassName()}>
                {isLeftSidebarCollapsed ?
                    <FontAwesomeIcon icon={faChevronRight} />
                    :
                    <FontAwesomeIcon icon={faChevronLeft} />
                }
            </div>
            {
                children.map((child, index) => {
                    if(!child) return null;

                    return (
                            <SidebarMenuItem key={`s${index}`} text={child.props.title} icon={child.props.icon} isResults={child.props.isResults}
                                isActive={child.props.title.toLowerCase() === selectedItemName} extraContent={child.props.children}
                                onClickHandler={() => { setSelectedItemName(child.props.title); }} 
                                extraClassName={styles.sidebarMenuItem} />
                    );
                })
            }
        </aside>
    );
};
